var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2383_1741)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1697 17.2736C25.3799 17.2917 26.5714 17.5739 27.6611 18.1007C28.8014 18.6333 29.8549 18.6638 31.0175 18.1417C32.3878 17.527 33.8332 17.0859 35.3735 17.2466C37.3445 17.4496 39.0655 18.157 40.3525 19.7361C40.6071 20.0482 40.688 20.2488 40.2563 20.5315C36.1502 23.2169 36.6758 29.5649 40.925 31.6919C41.4142 31.9371 41.4834 32.1776 41.2852 32.6703C40.4103 34.885 39.138 36.921 37.531 38.6782C36.3649 39.9429 34.9301 40.242 33.3076 39.7258C32.8465 39.578 32.3937 39.3985 31.9432 39.2202C30.5201 38.6547 29.0971 38.6676 27.6681 39.1932C27.1038 39.402 26.5348 39.5991 25.967 39.7986C24.7763 40.2209 23.7087 39.9593 22.7373 39.1991C21.4691 38.2077 20.5599 36.909 19.7422 35.5622C17.7876 32.336 16.7705 28.8434 17.0439 25.0482C17.2703 21.9065 19.1333 18.3294 23.1186 17.4308C23.5268 17.3358 23.9386 17.3064 24.1697 17.2736Z",
    fill: "#030303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2339 10.9542C35.1729 13.5903 32.9767 16.3508 30.4368 16.8623C29.2002 17.1087 29.1357 17.0535 29.2319 15.817C29.429 13.2829 31.5219 10.6222 34.8737 10.0133C35.16 9.96167 35.2691 10.0579 35.2374 10.3465C35.2198 10.5002 35.2339 10.6585 35.2339 10.9542Z",
    fill: "#070807"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2383_1741",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2383_1741"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2383_1741",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-Icon.fd258d036a9174b0bd3be31552b4952a.svg";
export { ForwardRef as ReactComponent };